import React, { useEffect, useState, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { commonBackInfo } from '../../utils';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { gamePlaceholder } from '../../constants/placeholder';

import type { GameListType } from '../../types';
import useGameList from '../../hooks/useGameList';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function GameListSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  platformSelect,
  oriDefaultFilter,
  backOriDefaultValue,
}: GameListType & { platformSelect: Array<string> }) {
  // 搜索的数据
  const [searchValue, setSearchValue] = useState('');
  const { gameOptions, basicOptions } = useGameList({
    platformSelect,
    searchValue,
  });

  const options = useMemo(() => {
    return gameOptions.map((item: any) => item.value);
  }, [gameOptions]);

  const basicOptionsList = useMemo(() => {
    return basicOptions.map((item: any) => item.value);
  }, [basicOptions]);

  const {
    selects: selectGameList,
    setSelects: setSelectGameList,
    isFirst,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    oriDefaultFilter,
    backOriDefaultValue,
    defaultKey: 'game_list',
    options: basicOptionsList,
    watchOptions: true,
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      defaultKey,
      commonBackInfo(
        { game_list: isAll ? [] : selectGameList },
        { [defaultKey]: text },
      ),
    );
  }, [selectGameList]);

  return (
    <div className={`game-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        searchInfo={[searchValue, setSearchValue]}
        placeholderText={gamePlaceholder[lang]}
        onClear={() => setSelectGameList([])}
        selectOptionsInfo={[selectGameList, setSelectGameList]}
        options={gameOptions}
        basicOptions={basicOptions}
        pointKey={FilterButtonPoint.game}
      ></CustomSelect>
    </div>
  );
}
